import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { getReviews, getReviewsEndpoint } from '@atlassian/mpac-api-client';
import { useEffect, useReducer, useRef } from 'react';
import { REVIEWS_ACTIONS, REVIEWS_STATUS, SORT_OPTIONS } from "../components/AppListing/tabs/ReviewsTab/utils";
const initialState = {
  status: REVIEWS_STATUS.LOADING_INITIAL,
  reviewsData: null,
  error: null,
  sortBy: SORT_OPTIONS.RECENT,
  hostingType: null
};

// eslint-disable-next-line complexity,max-lines-per-function
function reviewsReducer(state, action) {
  switch (action.type) {
    case REVIEWS_ACTIONS.SUCCESS:
      {
        var _state$reviewsData, _action$reviewsData;
        const currentReviews = ((_state$reviewsData = state.reviewsData) === null || _state$reviewsData === void 0 ? void 0 : _state$reviewsData.reviews) || [];
        const newlyFetchedReviews = ((_action$reviewsData = action.reviewsData) === null || _action$reviewsData === void 0 ? void 0 : _action$reviewsData.reviews) || [];
        const finalReviewsData = _objectSpread(_objectSpread({}, action.reviewsData), {}, {
          reviews: [...currentReviews, ...newlyFetchedReviews]
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          status: REVIEWS_STATUS.SUCCESS,
          reviewsData: finalReviewsData,
          error: null
        });
      }
    case REVIEWS_ACTIONS.REJECTED:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          status: REVIEWS_STATUS.REJECTED,
          error: action.error
        });
      }
    case REVIEWS_ACTIONS.SORT:
      {
        return _objectSpread(_objectSpread({}, initialState), {}, {
          sortBy: action.sortOption
        });
      }
    case REVIEWS_ACTIONS.LOAD_MORE:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          status: REVIEWS_STATUS.LOADING_MORE
        });
      }
    case REVIEWS_ACTIONS.DELETE:
      {
        var _state$reviewsData2;
        const currentReviews = ((_state$reviewsData2 = state.reviewsData) === null || _state$reviewsData2 === void 0 ? void 0 : _state$reviewsData2.reviews) || [];
        const filteredReviews = currentReviews.filter(review => review.selfEndpoint !== action.deletedReviewEndpoint);
        let finalReviewsData = null;
        if (state.reviewsData) {
          finalReviewsData = _objectSpread(_objectSpread({}, state.reviewsData), {}, {
            reviews: filteredReviews
          });
        }
        return _objectSpread(_objectSpread({}, state), {}, {
          reviewsData: finalReviewsData
        });
      }
    case REVIEWS_ACTIONS.DELETE_VENDOR_RESPONSE:
      {
        var _state$reviewsData3;
        const currentReviews = ((_state$reviewsData3 = state.reviewsData) === null || _state$reviewsData3 === void 0 ? void 0 : _state$reviewsData3.reviews) || [];
        let deletedVendorResponseReview = currentReviews[action.deletedResponseReviewIndex];
        deletedVendorResponseReview = _objectSpread(_objectSpread({}, deletedVendorResponseReview), {}, {
          vendor: _objectSpread(_objectSpread({}, deletedVendorResponseReview.vendor), {}, {
            response: null
          })
        });
        currentReviews[action.deletedResponseReviewIndex] = deletedVendorResponseReview;
        let finalReviewsData = null;
        if (state.reviewsData) {
          finalReviewsData = _objectSpread(_objectSpread({}, state.reviewsData), {}, {
            reviews: currentReviews
          });
        }
        return _objectSpread(_objectSpread({}, state), {}, {
          reviewsData: finalReviewsData
        });
      }
    case REVIEWS_ACTIONS.POST:
      {
        var _state$reviewsData4;
        const currentReviews = ((_state$reviewsData4 = state.reviewsData) === null || _state$reviewsData4 === void 0 ? void 0 : _state$reviewsData4.reviews) || [];
        const filteredReviews = currentReviews.filter(review => review.id !== action.postedReview.id);
        let reviewsWithPostedReview;
        if (action.isReviewApplicableForComplianceLogic && action.selfUserReviewStatus !== 'approved') {
          reviewsWithPostedReview = filteredReviews;
        } else {
          reviewsWithPostedReview = [action.postedReview, ...filteredReviews];
        }
        let reviewStatus;
        if (action.selfUserReviewStatus === 'approved') {
          reviewStatus = 'approved';
        } else if (action.isReviewApplicableForComplianceLogic) {
          reviewStatus = 'inprogress';
        } else {
          reviewStatus = undefined;
        }
        const selfUserReview = {
          id: action.postedReview.id,
          stars: action.postedReview.ratings.avgStars,
          review: action.postedReview.review,
          status: reviewStatus
        };
        let finalReviewsData = null;
        if (state.reviewsData) {
          finalReviewsData = _objectSpread(_objectSpread({}, state.reviewsData), {}, {
            reviews: reviewsWithPostedReview,
            selfUserReview
          });
        }
        return _objectSpread(_objectSpread({}, state), {}, {
          reviewsData: finalReviewsData
        });
      }
    case REVIEWS_ACTIONS.REFETCH:
      {
        return _objectSpread({}, initialState);
      }
    case REVIEWS_ACTIONS.SET_HOSTING_TYPE:
      {
        return _objectSpread(_objectSpread({}, initialState), {}, {
          hostingType: action.hostingType
        });
      }
    default:
      return state;
  }
}
export const useReviews = options => {
  const [state, dispatch] = useReducer(reviewsReducer, _objectSpread(_objectSpread({}, initialState), {}, {
    hostingType: options.hosting
  }));
  const isMounted = useRef(false);
  const {
    reviewsData,
    status,
    sortBy,
    error,
    hostingType
  } = state;
  const {
    appKey,
    hosting,
    mpacBaseUrl,
    isReviewApplicableForComplianceLogic
  } = options;
  const currentSortOption = sortBy;
  const showReviewsLoader = status === REVIEWS_STATUS.LOADING_INITIAL;
  const showMoreReviewsLoader = status === REVIEWS_STATUS.LOADING_MORE;
  const fetchReviews = async () => {
    try {
      const reviewsParams = {
        hosting,
        sort: sortBy
      };
      const reviewsEndpoint = (reviewsData === null || reviewsData === void 0 ? void 0 : reviewsData.moreReviewsEndpoint) || getReviewsEndpoint(appKey, reviewsParams);
      const reviewsUrl = "".concat(mpacBaseUrl).concat(reviewsEndpoint);
      const reviewsResponse = await getReviews(reviewsUrl);
      dispatch({
        type: REVIEWS_ACTIONS.SUCCESS,
        reviewsData: reviewsResponse
      });
    } catch (reviewsResponseError) {
      dispatch({
        type: REVIEWS_ACTIONS.REJECTED,
        error: reviewsResponseError
      });
    }
  };
  useEffect(() => {
    if (isMounted.current) {
      dispatch({
        type: REVIEWS_ACTIONS.SET_HOSTING_TYPE,
        hostingType: hosting
      });
    } else {
      isMounted.current = true;
    }
  }, [hosting]);
  useEffect(() => {
    fetchReviews();
  }, [sortBy, hostingType]);
  const sortReviewsBy = sortOption => {
    if (sortOption === sortBy) {
      return;
    }
    dispatch({
      type: REVIEWS_ACTIONS.SORT,
      sortOption
    });
  };
  const getMoreReviews = () => {
    dispatch({
      type: REVIEWS_ACTIONS.LOAD_MORE
    });
    fetchReviews();
  };
  const filterOutDeletedReview = deletedReviewEndpoint => {
    dispatch({
      type: REVIEWS_ACTIONS.DELETE,
      deletedReviewEndpoint
    });
  };
  const filterOutDeletedVendorResponse = deletedResponseReviewIndex => {
    dispatch({
      type: REVIEWS_ACTIONS.DELETE_VENDOR_RESPONSE,
      deletedResponseReviewIndex
    });
  };
  const renderPostedReview = review => {
    var _reviewsData$selfUser;
    dispatch({
      type: REVIEWS_ACTIONS.POST,
      postedReview: review,
      isReviewApplicableForComplianceLogic,
      selfUserReviewStatus: reviewsData === null || reviewsData === void 0 ? void 0 : (_reviewsData$selfUser = reviewsData.selfUserReview) === null || _reviewsData$selfUser === void 0 ? void 0 : _reviewsData$selfUser.status
    });
  };
  const refetchReviews = () => {
    dispatch({
      type: REVIEWS_ACTIONS.REFETCH
    });
    fetchReviews();
  };
  return {
    reviewsData,
    status,
    error,
    showReviewsLoader,
    showMoreReviewsLoader,
    getMoreReviews,
    sortReviewsBy,
    filterOutDeletedReview,
    currentSortOption,
    renderPostedReview,
    refetchReviews,
    filterOutDeletedVendorResponse
  };
};